import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Loader from "react-loaders"
import "./index.scss"
import AnimatedLetters from "../AnimatedLetters"
import { serviceItems } from "./serviceItems"
import ServiceOrderForm from "./ServiceOrderForm"

const Services = () => {
  const [activeServiceId, setActiveServiceId] = useState(null)
  const [letterClass, setLetterClass] = useState("text-animate")

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLetterClass("text-animate-hover")
    }, 3000)

    return () => {
      clearTimeout(timerId)
    }
  }, [])

  return (
    <>
      <div className="container services-page">
        <section className="services-content" aria-labelledby="services-title">
          <h1 id="services-title">
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                "M",
                "e",
                "s",
                " ",
                "S",
                "e",
                "r",
                "v",
                "i",
                "c",
                "e",
                "s",
              ]}
              index={15}
            />
          </h1>
          <p className="services-overline">
            Ce Que Je Peux Construire Pour Vous
          </p>
          <p className="services-intro">
            J'accompagne entreprises, entrepreneurs et équipes produit dans la
            conception de solutions numériques performantes, durables et
            orientées impact. Chaque service est pensé pour transformer vos
            objectifs en résultats concrets.
          </p>

          <div className="services-grid">
            {serviceItems.map((item, index) => (
              <article key={item.id} className="service-card">
                <figure className="service-media">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    loading={index < 2 ? "eager" : "lazy"}
                    decoding="async"
                  />
                </figure>

                <div className="service-card-body">
                  <p className="service-highlight">{item.highlight}</p>
                  <h2>{item.title}</h2>
                  <p>{item.description}</p>

                  <ServiceOrderForm
                    service={item}
                    isOpen={activeServiceId === item.id}
                    onOpen={() => setActiveServiceId(item.id)}
                    onClose={() => setActiveServiceId(null)}
                  />
                </div>
              </article>
            ))}
          </div>

          <div className="services-cta-wrap">
            <p>
              Un projet en tête ? Discutons de la meilleure stratégie ensemble.
            </p>
            <Link to="/contact" className="services-cta">
              Démarrer une collaboration
            </Link>
          </div>
        </section>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Services
